<template>
  <div class="page-modulandlang">
    <SetHeader />
    <TabsLangs
      :checkLang="langCode"
      :checkLangChange="checkLangChange"
      :dataSource="langList"
    />
    <div v-if="isShow">
      <Container />
      <div class="h100"></div>
      <div class="bottomBar">
        <div class="fr">
          <a-button type="default" class="mr10" @click="() => jumpPage()"
            >取消</a-button
          >
          <a-button
            type="primary"
            :loading="saving"
            :disabled="saving"
            @click="() => save()"
          >
            {{ saving ? '保存中...' : '保存' }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
  <BigPic />
  <!-- Subscribe新增弹窗 -->
  <SubscribeModal>
    <TabsLangs
      :checkLang="langCode"
      :checkLangChange="checkLangChange"
      :dataSource="langList"
    />
  </SubscribeModal>
</template>
<script>
import SubscribeModal from './components/SubscribeModal.vue'
import {
  toRefs,
  reactive,
  onMounted,
  provide,
  nextTick,
  watch,
  computed
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SetHeader from './components/SetHeader.vue'
import TabsLangs from './components/TabsLangs.vue'
import Container from './components/Container.vue'
import BigPic from './components/BigPic.vue'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
const {
  commonConfig_integratedConfig_detail_post_,
  commonConfig_integratedConfig_save_post_
} = useAPI(null, [7056])
import { common_lang_get } from 'server/modules/3426'
export default {
  components: {
    SetHeader,
    TabsLangs,
    Container,
    BigPic,
    SubscribeModal
  },
  setup() {
    const routeQuery = useRoute().query
    const { channelId, siteId, brandId, terminalId } = routeQuery

    // const getIntegratedConfigPublic = () => ({
    //   footerReviewIconUrl: '', // 评论icon的url

    //   footerTransportIconList: [], // 物流Icon列表
    //   socialMediaIconList: [], // 社交媒体列表
    //   // footerTransportLink: '', // 物流Icon链接

    //   footerPayIconList: [], // 支付Icon列表
    //   // footerPayLink: '', // 支付Icon
    //   checkoutSubscribeStatus: 1, // 订阅状态
    //   checkoutSubscribeDefault: false, //是否默认订阅

    //   checkoutCacheAddress: 1, // 地址缓存 -1.默认勾选、2.默认不勾选
    //   registerPrivacyPolicy: 1, // 隐私条款状态 -1.默认勾选、2.默认不勾选
    //   registerSubscribeStatus: 1, // 订阅状态 -1.默认勾选、2.默认不勾选
    //   checkoutSmsSubscribeShow: false, // 是否展示sms订阅
    //   checkoutSmsSubscribeStatus: 2, // sms订阅勾选状态 -1.默认勾选、2.默认不勾选

    //   checkoutSmsSubscribeIcon: null, // sms订阅icon

    //   integratedSubscribeList: [] //订阅场景配置
    // })
    // const getIntegratedConfigPrivate = () => ({
    //   // langs: [], //多语言列表
    //   footerPrivacyPolicyText: '', // footer隐私条款文案
    //   checkoutSubscribeText: '', // 订阅文案

    //   footerSubscribeTitle: '', // 订阅标题
    //   footerSubscribeDescription: '', // 订阅描述
    //   footerSubscribePlaceholderText: '', // 输入框提示文案
    //   footerSubscribeButtonText: '', // 按钮文案
    //   footerSubscribeSuccessDesc: '', // 订阅成功描述
    //   footerSeoText: '', // SEO文案
    //   footerPcReviewIcon: '', // 评论icon M
    //   footerMReviewIcon: '', // 评论icon PC
    //   footerVersionInfo: '', // 版本信息
    //   footerTransportTitle: '', // 物流Icon标题

    //   footerTransportLink: '', // 物流Icon链接
    //   footerPayTitle: '', // 支付Icon标题
    //   footerPayLink: '', // 支付Icon

    //   checkoutFreightInsuranceTips: '', // 运费险提示

    //   checkoutSmsSubscribeText: null, // sms订阅文案
    //   checkoutSmsSubscribeDesc: null, // sms订阅描述

    //   registerSubscribeText: '' // 注册订阅文案
    // })

    const state = reactive({
      saving: false,
      modalData: {
        scene: '',
        pcStatus: '',
        mStatus: ''
      },
      defaultCurrency: '',
      changeTabType: () => {
        setTimeout(() => {
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }, 10)
      },
      inputLengthCut: (val, key, type = 1) => {
        let value = val
          .split('')
          .splice(0, 20)
          .join('')
        state[`popupSet${type}`][key] = value
      },
      changeIconText: e => {
        const value = e.target.value
        if (!value) {
          state.checkLangData.footerReviewIconText = null
        }
      },
      getLangs: (param = {}) => {
        const subscribeListLangsInit = []
        state.langList.map(item => {
          const data = {
            ...param,
            channelId,
            siteId,
            brandId,
            terminalId,
            langCode: item.value
          }
          subscribeListLangsInit.push(data)
        })

        return subscribeListLangsInit
      },
      isShow: true,
      languageMap: [],
      disabled: false,
      langs: [],
      langList: [],
      bigPic: null,
      visiblePic: false,
      changeVisiblePic: (visiblePic = false, bigPic = null) => {
        state.visiblePic = visiblePic
        state.bigPic = bigPic
      },
      upload: (info = null, index, key, isPrivate = false) => {
        state.fileList = [info.file]
        state.info = info
        const { file } = info
        const isLtMaxM = file.size / 1024 <= 50
        if (isLtMaxM) {
          state.uploadHandleChange(index, key, isPrivate)
        } else {
          message.warning('上传大小不能超过50k!')
          return
        }
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      isSize: (file, proportion) => {
        return new Promise((resolve, reject) => {
          let _URL = window.URL || window.webkitURL
          let img = new Image()
          img.onload = () => {
            let valid = img.width / img.height === proportion
            valid ? resolve(true) : reject(false)
          }
          img.src = _URL.createObjectURL(file)
        })
      },
      descTitle: computed(() => {
        return state.integratedConfig.integratedConfigPhoneSubscribe
          .checkoutPhoneSubscribeType === 1
          ? 'SMS'
          : state.integratedConfig.integratedConfigPhoneSubscribe
              .checkoutPhoneSubscribeType === 2
          ? 'WhatsApp'
          : ''
      }),
      uploadHandleChange: async (index = null, key, isPrivate) => {
        const { info, integratedConfig, checkLangData } = state
        let isSize = true
        if (
          [
            'checkoutSmsSubscribeIcon',
            'checkoutWhatsappSubscribeIcon'
          ].includes(key)
        ) {
          isSize = await state.isSize(info.file, 52 / 80).catch(err => {
            console.log(err)
            isSize = false
          })
        }
        if (!isSize) {
          return message.warning('图片尺寸不符合')
        }
        const dataSource = isPrivate ? checkLangData : integratedConfig
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            if (
              ['footerTransportIconList', 'footerPayIconList'].includes(key)
            ) {
              dataSource[key][index].imgUrl = url
            } else {
              if (['socialMediaIconList'].includes(key)) {
                dataSource.socialMediaIconList[index] = {
                  ...dataSource.socialMediaIconList[index],
                  imgUrl: url
                }
              } else if (
                [
                  'checkoutSmsSubscribeIcon',
                  'checkoutWhatsappSubscribeIcon'
                ].includes(key)
              ) {
                dataSource.integratedConfigPhoneSubscribe[key] = url
              } else {
                dataSource[key] = url
              }
            }
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      tabType: 1,
      tabTypeChange: (tabType = 1) => {
        state.tabType = tabType
        // state.popupParams.popType = tabType - 0 === 1 ? 1 : 2
      },
      jumpPage: () => {
        state.router.push({
          path: 'PublicSet',
          query: {
            ...state.route.query
          }
        })
      },
      handleSwitchChange(record, index) {
        const { langs, pcStatus, mStatus } = record
        if (!langs) {
          return
        }
        state.integratedConfig.integratedSubscribeList[
          index
        ].langs = record.langs.map(item => ({ ...item, pcStatus, mStatus }))
      },
      removeMedia: index => {
        state.integratedConfig.socialMediaIconList.splice(index, 1)
      },
      addMedia: () => {
        state.integratedConfig.socialMediaIconList = [
          ...state.integratedConfig.socialMediaIconList,
          { imgUrl: null, link: null }
        ]
      },
      initList: async () => {
        let params = {
          ...state.queryParams
        }
        if (params.lang) {
          delete params.lang
        }
        let api = commonConfig_integratedConfig_detail_post_
        await api(params, state)
        if (!state.integratedConfig.id) {
          state.langs = state.getLangs()
        }
        state.integratedConfig.integratedConfigPhoneSubscribe = state
          .integratedConfig.integratedConfigPhoneSubscribe
          ? state.integratedConfig.integratedConfigPhoneSubscribe
          : {
              checkoutPhoneSubscribeType: 0
            }

        const modelList = state.integratedConfig.integratedSubscribeList
        if (Array.isArray(modelList) && modelList.length) {
          state.integratedConfig.integratedSubscribeList.map((item, index) => {
            if (!item || (Array.isArray(item.langs) && !item.langs.length)) {
              state.integratedConfig.integratedSubscribeList[index][
                'langs'
              ] = state.getLangs(item)
            } else {
              state.integratedConfig.integratedSubscribeList[index][
                'langs'
              ] = item.langs.map(subItem => {
                return {
                  ...item,
                  ...subItem
                }
              })
            }
          })
        }

        // Initialize subscriptionComponentList
        if (
          state.integratedConfig.subscriptionComponentList &&
          Array.isArray(state.integratedConfig.subscriptionComponentList)
        ) {
          state.subscriptionComponentList = state.integratedConfig.subscriptionComponentList.map(
            item => ({
              ...item,
              statusM: item.statusM === 1,
              statusPc: item.statusPc === 1
            })
          )
        }

        checkLangDataInit()
        state.scrollResize()
      },
      checkLangData: {},
      integratedConfig: {
        id: '',
        langs: [], //多语言列表
        footerPrivacyPolicyText: '', // footer隐私条款文案
        footerReviewIconUrl: '', // 评论icon的url
        footerSubscribeTitle: '', // Email订阅标题
        footerSubscribeDescription: '', // Email订阅描述
        footerSubscribePlaceholderText: '', // Email订阅输入框提示文案
        footerSubscribeButtonText: '', // Email订阅按钮文案
        footerSubscribeSuccessDesc: '', // Email订阅成功描述
        footerSmsSubscribeTitle: '', // SMS订阅标题
        footerSmsSubscribeDescription: '', // SMS订阅描述
        footerSmsSubscribePlaceholderText: '', // SMS订阅输入框提示文案
        footerSmsSubscribeButtonText: '', // SMS订阅按钮文案
        footerSmsSubscribeSuccessDesc: '', // SMS订阅成功描述
        footerSeoText: '', // SEO文案
        footerPcReviewIcon: '', // 评论icon M
        footerMReviewIcon: '', // 评论icon PC
        footerVersionInfo: '', // 版本信息
        footerTransportTitle: '', // 物流Icon标题
        footerTransportIconList: [], // 物流Icon列表
        socialMediaIconList: [], // 社交媒体列表
        footerTransportLink: '', // 物流Icon链接
        footerPayTitle: '', // 支付Icon标题
        footerPayIconList: [], // 支付Icon列表
        footerPayLink: '', // 支付Icon
        checkoutSubscribeStatus: 1, // 订阅状态
        checkoutSubscribeDefault: false, //是否默认订阅
        checkoutSubscribeText: '', // 订阅文案
        checkoutFreightInsuranceTips: '', // 运费险提示
        checkoutCacheAddress: 1, // 地址缓存 -1.默认勾选、2.默认不勾选
        registerPrivacyPolicy: 1, // 隐私条款状态 -1.默认勾选、2.默认不勾选
        registerSubscribeStatus: 1, // 订阅状态 -1.默认勾选、2.默认不勾选
        checkoutSmsSubscribeShow: false, // 是否展示sms订阅
        checkoutSmsSubscribeStatus: 2, // sms订阅勾选状态 -1.默认勾选、2.默认不勾选
        checkoutSmsSubscribeText: null, // sms订阅文案
        checkoutSmsSubscribeDesc: null, // sms订阅描述
        checkoutSmsSubscribeIcon: null, // sms订阅icon
        registerPrivacyPolicyText: '', // 注册隐私条款文案
        registerSubscribeText: '', // 注册订阅文案
        showEmailSubscribe: true, // 展示Email订阅
        showSmsSubscribe: true, // 展示SMS订阅
        showByUserSubscribeStatus: false, // 根据用户订阅状态
        integratedSubscribeList: [], //订阅场景配置
        emailSubscribePcEnable: 0, // Email订阅 PC端启用状态 -0.禁用、1.启用
        emailSubscribeMEnable: 0, // Email订阅 M端启用状态 -0.禁用、1.启用
        emailSubscribeTitle: '', // Email订阅-标题
        emailSubscribeDescription: '', // Email订阅-描述
        emailSubscribeButtonText: '', // Email订阅-按钮文案
        emailSubscribeSuccessDesc: '', // Email订阅-订阅成功描述
        integratedConfigPhoneSubscribe: {
          checkoutPhoneSubscribeType: 0,
          checkoutSmsSubscribeDesc: null,
          checkoutSmsSubscribeIcon: null,
          checkoutSmsSubscribeStatus: null,
          checkoutSmsSubscribeText: null,
          checkoutWhatsappSubscribeDesc: null,
          checkoutWhatsappSubscribeIcon: null,
          checkoutWhatsappSubscribeStatus: null,
          checkoutWhatsappSubscribeText: null,
          langs: []
        }
      },
      changeSubscribeType: () => {
        state.checkLangData.checkoutSmsSubscribeDesc = null
        state.checkLangData.checkoutSmsSubscribeText = null
        state.checkLangData.checkoutWhatsappSubscribeDesc = null
        state.checkLangData.checkoutWhatsappSubscribeText = null
        state.integratedConfig.integratedConfigPhoneSubscribe.checkoutSmsSubscribeIcon = null
        state.integratedConfig.integratedConfigPhoneSubscribe.checkoutWhatsappSubscribeIcon = null
      },
      addIcon: (key = null) => {
        state.integratedConfig[key] = [
          ...state.integratedConfig[key],
          { imgUrl: null, link: null }
        ]
      },
      popupSet: {
        buttonTextTwo: null,
        buttonText: '', // 按钮文案
        cookieText: '', // cookie提示
        mImgUrl: '', //mText
        pcImgUrl: '', // 图片url-pc
        pcText: '', // 文案-pc
        mText: '', // 文案-m
        popupId: '', //popup配置
        type: '' // 弹窗类型。1.订阅弹窗默认，2.初次订阅成功，3.重新订阅成功，4.注册弹窗
      },
      popupSet1: {},
      popupSet2: {},
      popupSet3: {},
      popupSet4: {
        buttonText: '', // 按钮文案
        cookieText: '', // cookie提示
        mImgUrl: '', //mText
        pcImgUrl: '', // 图片url-pc
        pcText: '', // 文案-pc
        mText: '', // 文案-m
        popupId: '', //popup配置
        type: 4
      },
      popupParams: {},
      restPopupParams: {
        creator: null, // 创建人
        delayTime: 5, //弹窗延迟出现时间,单位秒
        filterUrl: null, // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割；
        id: null, //主键id
        modifier: null, // 修改人
        oncePopPerUser: true, // 每个用户仅弹出一次- 0.否 、1. 是
        popType: 1, //弹窗类型-1.订阅弹窗、2.注册弹窗
        popupTextDTOS: [], //弹窗文案集合
        sidebarContent: null, //侧边栏内容
        sidebarType: 1, // 侧边栏类型 1.文本、2.图片
        status: 0, // 状态 -0.禁用、1.启用
        userType: 1 //触发用户类型-1.所有用户（新访+老访）、2.新用户（新访）、3.未注册用户（新访+老访的未注册用户)
      },
      topBarItem: {
        color: '#000000', // 颜色
        countdown: 0, // 0 不开启 1 开启
        endTime: null, // 倒计时活动结束时间
        link: null, // 链接
        orderNum: 0, // 顺序
        startTime: null, // 活动开始时间
        text: null, // 文案
        topbarConfigId: null,
        times: [] // topbar 配置id
      },
      removeTopbar: (index = 1) => {
        state.topbarParams.topbarItemDTOList.splice(index, 1)
      },
      addTopBarItem: () => {
        if (!state.topbarParams.topbarItemDTOList) {
          state.topbarParams.topbarItemDTOList = []
        }
        state.topbarParams.topbarItemDTOList.splice(
          state.topbarParams.topbarItemDTOList.length - 1,
          0,
          { ...state.topBarItem }
        )
        // state.topbarParams.topbarItemDTOList = [
        //   ...state.topbarParams.topbarItemDTOList,
        //   { ...state.topBarItem }
        // ]
      },
      topbarParams: {},
      resetTopbarParams: {
        backCol: '#000000', //背景颜色
        ceiling: true, // 是否吸顶-0.否、1.是
        creator: null, // 创建人
        filterUrl: '', // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割
        id: null, // 主键id
        leftRightTime: 5, // 左右轮播时间，单位秒
        modifier: null, //修改人
        status: 0, //状态 -0.禁用、1.启用
        topbarItemDTOList: [
          {
            addButton: false,
            color: '#000000', // 颜色
            countdown: 0, // 0 不开启 1 开启
            endTime: null, // 倒计时活动结束时间
            link: null, // 链接
            orderNum: 0, // 顺序
            startTime: null, // 活动开始时间
            text: null, // 文案
            topbarConfigId: null // topbar 配置id
          },
          {
            addButton: true,
            color: '#000000', // 颜色
            countdown: 0, // 0 不开启 1 开启
            endTime: null, // 倒计时活动结束时间
            link: null, // 链接
            orderNum: 0, // 顺序
            startTime: null, // 活动开始时间
            text: null, // 文案
            topbarConfigId: null // topbar 配置id
          }
        ], // topbar子项
        upDownTime: 5 // 上下轮播时间，单位秒
      },
      queryParams: {},
      route: useRoute(),
      router: useRouter(),
      activeKey: 1,
      check: 1,
      langCode: '',
      defaultLang: '',
      checkChange: (check = 1) => {
        state.check = check
      },
      checkLangChange: (langCode = '') => {
        state.langCode = langCode
        state.setModalData()
        state.scrollResize()
      },
      scrollResize() {
        if (!state.subscribeModal) {
          const dom = document.querySelector('.page-modulandlang')
          if (dom) {
            dom.style.height = '0'
          }
          nextTick(() => {
            dom.style.height = 'auto'
          })
        }
      },
      save: async () => {
        // 将save方法改为async
        // 如果正在保存，直接返回
        if (state.saving) {
          return
        }

        // 设置保存状态
        state.saving = true

        try {
          let footerTransportIconList = []
          let footerTransportIconListIndex = 0
          let footerPayIconList = []
          let footerPayIconListIndex = 0

          // ... 原有的save逻辑保持不变
          state.integratedConfig.footerTransportIconList.map(v => {
            if (
              !(
                [null, undefined, ''].includes(v.imgUrl) &&
                [null, undefined, ''].includes(v.link)
              )
            ) {
              footerTransportIconList.push({
                ...v,
                orderNum: footerTransportIconListIndex++
              })
            }
          })

          state.integratedConfig.footerPayIconList.map(v => {
            if (
              !(
                [null, undefined, ''].includes(v.imgUrl) &&
                [null, undefined, ''].includes(v.link)
              )
            ) {
              footerPayIconList.push({
                ...v,
                orderNum: footerPayIconListIndex
              })
            }
          })

          let mediaWarning = 0
          state.integratedConfig.socialMediaIconList.map(v => {
            if ([null, undefined, ''].includes(v.imgUrl)) {
              mediaWarning++
            }
          })

          if (mediaWarning) {
            message.warning('社交媒体Icon图片不能为空！')
            return
          }

          const subscribes = state.langs?.map(item => ({
            checkoutSmsSubscribeDesc: item.checkoutSmsSubscribeDesc,
            checkoutSmsSubscribeText: item.checkoutSmsSubscribeText,
            checkoutWhatsappSubscribeDesc: item.checkoutWhatsappSubscribeDesc,
            checkoutWhatsappSubscribeText: item.checkoutWhatsappSubscribeText,
            langCode: item.langCode
          }))

          // 将 Payment Successful Email订阅字段同步到最外层
          const defaultLangData = state.langs.find(
            item => item.langCode === state.defaultLang
          )
          if (defaultLangData) {
            state.integratedConfig.emailSubscribeTitle =
              defaultLangData.emailSubscribeTitle || ''
            state.integratedConfig.emailSubscribeDescription =
              defaultLangData.emailSubscribeDescription || ''
            state.integratedConfig.emailSubscribeButtonText =
              defaultLangData.emailSubscribeButtonText || ''
            state.integratedConfig.emailSubscribeSuccessDesc =
              defaultLangData.emailSubscribeSuccessDesc || ''
          }

          const { channelId, siteId, brandId, terminalId } = routeQuery
          let postParams = {
            channelId,
            siteId,
            brandId,
            terminalId,
            ...state.integratedConfig,
            ...state.queryParams,
            langs: state.langs,
            footerTransportIconList,
            footerPayIconList,
            integratedConfigSidebarDTOS: state.data?.map(item => ({
              ...item,
              statusM: item.statusM ? 1 : 0,
              statusPc: item.statusPc ? 1 : 0
            })),
            subscriptionComponentList: state.subscriptionComponentList?.map(
              item => ({
                ...item,
                statusM: item.statusM ? 1 : 0,
                statusPc: item.statusPc ? 1 : 0
              })
            )
          }

          let iconMsg = []
          const langs = state.langList?.map(item => item.value)
          postParams.langs.map(item => {
            if (
              postParams.footerReviewIconTextEnable &&
              !item.footerReviewIconText &&
              langs.includes(item.langCode)
            ) {
              iconMsg.push(item.langCode)
            }
          })

          if (iconMsg?.length) {
            const iconDom = document.querySelector('.iconerror')
            if (iconDom) {
              iconDom.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            message.warning(`请检查${iconMsg?.join(',')}下的展示文案！`)
            return
          }

          // Payment Successful Email订阅字段必填校验
          // 检查 quillEditor HTML 内容是否为空的辅助函数
          const isQuillContentEmpty = html => {
            if (!html || html.trim() === '') return true
            // 移除所有 HTML 标签，检查是否还有文本内容
            const textContent = html
              .replace(/<[^>]*>/g, '')
              .replace(/&nbsp;/g, ' ')
              .trim()
            return textContent === ''
          }

          let emailSubscribeMsg = []
          postParams.langs.map(item => {
            const missingFields = []
            if (
              !item.emailSubscribeTitle ||
              item.emailSubscribeTitle.trim() === ''
            ) {
              missingFields.push('Email订阅-标题')
            }
            if (isQuillContentEmpty(item.emailSubscribeDescription)) {
              missingFields.push('Email订阅-描述')
            }
            if (
              !item.emailSubscribeButtonText ||
              item.emailSubscribeButtonText.trim() === ''
            ) {
              missingFields.push('Email订阅-按钮文案')
            }
            if (isQuillContentEmpty(item.emailSubscribeSuccessDesc)) {
              missingFields.push('Email订阅-订阅成功描述')
            }
            if (missingFields.length > 0) {
              emailSubscribeMsg.push({
                langCode: item.langCode,
                fields: missingFields
              })
            }
          })

          if (emailSubscribeMsg?.length) {
            const errorMessages = emailSubscribeMsg.map(
              item => `${item.langCode}：${item.fields.join('、')}不能为空`
            )
            message.warning(errorMessages.join('；'))
            // 滚动到第一个错误字段
            const errorDom = document.querySelector('.error-message')
            if (errorDom) {
              errorDom.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            return
          }

          postParams.integratedConfigPhoneSubscribe.langs = subscribes
          for (let i = 0; i < postParams.socialMediaIconList.length; i++) {
            postParams.socialMediaIconList[i].orderNum = i + 1
          }

          let api = commonConfig_integratedConfig_save_post_
          await api(postParams, state) // 等待API调用完成
        } catch (error) {
          console.error('保存失败:', error)
          message.error('保存失败，请重试')
        } finally {
          // 1秒后恢复按钮可用状态
          setTimeout(() => {
            state.saving = false
          }, 1000)
        }
      }, //subscribeList
      subscribeList: [],
      //subscribeModal
      subscribeModal: false,
      //0新增 1编辑
      subscribeTitleType: 0,
      //subscribeFormState
      subscribeFormRef: null,
      subscribeFormState: {
        scene: null,
        pcStatus: false,
        mStatus: false,
        subscriptionText: null,
        unsubscribedButtonText: null,
        subscribedButtonText: null,
        subscriptionSuccessText: null
      },
      _subscribeFormState: {},
      resetSubscribeFormState: () => {
        state.subscribeFormState = {
          scene: null,
          pcStatus: false,
          mStatus: false,
          subscriptionText: null,
          unsubscribedButtonText: null,
          subscribedButtonText: null,
          subscriptionSuccessText: null
        }
      },
      subscribeSelectList: [
        {
          label: '商品详情页',
          value: 1
        },
        {
          label: '个人中心-订单列表页面',
          value: 2
        },
        {
          label: '个人中心-订单详情页面',
          value: 3
        },
        {
          label: '个人中心-查询物流页面',
          value: 4
        },
        {
          label: 'footer-查询物流页面',
          value: 5
        },
        {
          label: '个人中心-心愿单',
          value: 6
        },
        {
          label: '个人中心-个人信息',
          value: 7
        },
        {
          label: '个人中心-会员中心-券',
          value: 8
        },
        {
          label: '个人中心-退货历史',
          value: 9
        }
      ],
      subscribeMapList: [],
      subscribeFormRules: {
        scene: [{ required: true, message: '请选择订阅场景!' }],
        subscriptionText: [
          { required: true, message: '请输入订阅文案！' },
          { max: 200, message: '最大长度200字符' }
        ],
        unsubscribedButtonText: [
          { required: true, message: '请输入未订阅按钮！' },
          { max: 50, message: '最大长度50字符' }
        ],
        subscribedButtonText: [
          { required: true, message: '请输入已订阅按钮！' },
          { max: 50, message: '最大长度50字符' }
        ],
        subscriptionSuccessText: [
          { required: true, message: '请输入订阅成功文案！' },
          { max: 50, message: '最大长度50字符' }
        ]
      },
      setModalData() {
        const { subscribeFormState = {}, langCode = '' } = state
        const { langs = [] } = subscribeFormState
        const result = langs.find(item => item.langCode === langCode)
        state.modalData = result || {}
        console.log('result', result)
      },
      //activeIndex
      activeIndex: 0,
      subscribeAdd: () => {
        state.getSubscribeMapList()
        state.resetSubscribeFormState()
        state.subscribeTitleType = 0
        state.subscribeModal = true
        state.subscribeFormState.langs = state.getLangs(
          state.subscribeFormState
        )
        state.setModalData()
        nextTick(() => {
          state.subscribeFormRef.clearValidate()
        })
      },
      getSubscribeMapList: () => {
        state.subscribeMapList = state.subscribeSelectList.filter(
          item =>
            !state.integratedConfig.integratedSubscribeList.some(
              data => item.value === data.scene
            )
        )
      },
      subscribeSave: () => {
        state.subscribeFormRef
          .validate()
          .then(() => {
            if (!state.subscribeTitleType) {
              const subscribeFormData = state.modalData
              const obj = {
                ...subscribeFormData,
                langs: state.subscribeFormState.langs,

                scene: subscribeFormData.scene,
                mStatus: subscribeFormData.mStatus ? 1 : 0,
                pcStatus: subscribeFormData.pcStatus ? 1 : 0
              }
              state.integratedConfig.integratedSubscribeList.unshift(obj)
            } else {
              state.integratedConfig.integratedSubscribeList[
                state.activeIndex
              ] = {
                ...state.subscribeFormState,
                scene: state.modalData.scene,
                mStatus: state.modalData.mStatus ? 1 : 0,
                pcStatus: state.modalData.pcStatus ? 1 : 0
              }

              state.resetSubscribeFormState()
            }
            state.subscribeModal = false
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      delRow: index => {
        state.integratedConfig.integratedSubscribeList.splice(index, 1)
      },
      editRow: (info, index) => {
        if (Object.keys(info)) {
          state._subscribeFormState = JSON.parse(JSON.stringify(info))
        }
        state.getSubscribeMapList()
        state.subscribeMapList.push(
          state.subscribeSelectList.find(item => item.value === info.scene)
        )

        state.subscribeTitleType = 1
        state.subscribeModal = true
        state.subscribeFormState = {
          ...info,
          mStatus: info.mStatus ? true : false,
          pcStatus: info.pcStatus ? true : false
        }
        state.activeIndex = index
        state.setModalData()

        nextTick(() => {
          state.subscribeFormRef.clearValidate()
        })
      },
      handleMdalClose() {
        const { _subscribeFormState } = state
        if (Object.keys(_subscribeFormState).length) {
          state.integratedConfig.integratedSubscribeList[state.activeIndex] = {
            ..._subscribeFormState
          }
          state._subscribeFormState = {}
        }
      },
      title: '新增',
      visible: false,
      comVisible: false,
      subComRecord: {
        componentPage: 1,
        langs: [],
        statusM: 1,
        statusPc: 1
      },
      comIndex: null,
      handleComEdit: (record, index) => {
        state.title = '编辑'
        state.subComRecord = JSON.parse(JSON.stringify(record))
        state.subComRecord.langs?.forEach(item => {
          item.label = state.langList?.find(
            lang => lang.value === item.langCode
          )?.label
        })
        console.log(state.subComRecord)
        console.log(state.langList)
        debugger
        state.comIndex = index
        state.comVisible = true
      },
      handleSaveCom: () => {
        const errors = []
        state.subComRecord.langs.forEach(item => {
          if (!item.bgImgM || !item.bgImgPc) {
            errors.push(`${item.label}背景图不能为空`)
          }
          if (!item.subscriptionTitle) {
            errors.push(`${item.label}订阅标题不能为空`)
          }
          if (!item.subscriptionSubtitle) {
            errors.push(`${item.label}订阅副标题不能为空`)
          }
          if (!item.unsubscribedButton) {
            errors.push(`${item.label}未订阅按钮不能为空`)
          }
          if (!item.subscribedButton) {
            errors.push(`${item.label}已订阅按钮不能为空`)
          }
          if (!item.emailSuccessTitle) {
            errors.push(`${item.label}Email订阅成功标题不能为空`)
          }
          if (!item.emailSuccessSubtitle) {
            errors.push(`${item.label}Email订阅成功副标题不能为空`)
          }
          if (!item.smsSuccessTitle) {
            errors.push(`${item.label}SMS订阅成功标题不能为空`)
          }
          if (!item.smsSuccessSubtitle) {
            errors.push(`${item.label}SMS订阅成功副标题不能为空`)
          }
          if (!item.emailSmsSuccessTitle) {
            errors.push(`${item.label}Email+SMS订阅成功标题不能为空`)
          }
          if (!item.emailSmsSuccessSubtitle) {
            errors.push(`${item.label}Email+SMS订阅成功副标题不能为空`)
          }
          if (!item.subscriptionAgreement) {
            errors.push(`${item.label}订阅协议不能为空`)
          }
        })
        const filterType = state.subscriptionComponentList.filter(
          item => item.componentPage === state.subComRecord.componentPage
        )
        if (filterType.length >= 1 && state.comIndex === null) {
          return message.warning('该组件页面已存在')
        }
        if (errors.length) {
          return message.warning(errors.join('\n'))
        }
        if (state.comIndex === null) {
          state.subscriptionComponentList.push(state.subComRecord)
        } else {
          state.subscriptionComponentList[state.comIndex] = state.subComRecord
        }
        state.comVisible = false
      },
      data: [],
      subscriptionComponentList: [],
      typeOptions: [
        { label: '订阅弹窗', value: 1 },
        { label: 'APP引流', value: 2 },
        { label: 'LiveChat', value: 3 },
        { label: '返回顶部', value: 4 }
      ],
      handleAdd: () => {
        state.index = null
        state.formState = {
          type: null,
          statusPc: null,
          statusM: null,
          filterUrl: null,
          iconUrl: null
        }
        state.visible = true
      },
      handleAddCom: () => {
        state.title = '新增'
        state.comIndex = null
        state.subComRecord = {
          componentPage: 1,
          langs: state.langList.map(item => ({
            ...item,
            langCode: item.value
          })),
          statusM: true,
          statusPc: true
        }
        state.comVisible = true
      },
      handleEdit: (record, index) => {
        state.title = '编辑'
        state.visible = true
        state.index = index
        state.formState = JSON.parse(JSON.stringify(record))
      },
      loading: false,
      uploadImg: async file => {
        state.loading = true
        const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
        const { success, data } = await formRequest(api, {
          file: file.file
        })
        if (success) {
          state.loading = false
          state.formState.iconUrl = data.url
        }
      },
      uploadCom: async (file, item, key) => {
        const fileType = file.file.type
        console.log(fileType)
        // 定义允许的图片类型
        const allowedTypes = [
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/svg+xml'
        ]
        // 判断是否是图片
        if (!allowedTypes.includes(fileType)) {
          return message.warning('只能上传图片文件!')
        }
        state.loading = true
        const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
        const { success, data } = await formRequest(api, {
          file: file.file
        })
        if (success) {
          state.loading = false
          item[key] = data.url
        }
      },
      formState: {
        type: null,
        statusPc: null,
        statusM: null,
        filterUrl: null,
        iconUrl: null
      },
      handleDelete: index => {
        state.data.splice(index, 1)
      },
      handleDeleteCom: index => {
        state.subscriptionComponentList.splice(index, 1)
      },
      labelCol: { span: 6 },
      index: null,
      handleOk: () => {
        const params = {
          ...state.formState
        }
        if (!params.type) {
          return message.warning('请选择类型')
        }
        const dataLength = state.data.filter(item => item.type === params.type)
        if (dataLength.length >= 1 && state.index === null) {
          return message.warning('同一类型只能存在一个')
        }
        if (params.type !== 1 && !params.iconUrl) {
          return message.warning('请上传icon图片')
        }
        if (state.index === null) {
          state.data.push(params)
        } else {
          state.data[state.index] = params
        }
        state.visible = false
      }
    })

    const checkLangDataInit = () => {
      const result = []

      const { langCode = '', integratedConfig = {} } = state
      if (!langCode) {
        return
      }

      if (!integratedConfig.langs || !integratedConfig.langs.length) {
        const initData = state.getLangs()

        const data =
          Object.prototype.toString.call(integratedConfig) ===
            '[object Object]' && JSON.parse(JSON.stringify(integratedConfig))
        if (data.langs) {
          delete data.langs
        }
        initData.map((item, index) => {
          if (index === 0) {
            result[index] = {
              ...data,
              ...item
            }
          } else {
            result[index] = {
              // ...getIntegratedConfigPrivate(),
              ...item
            }
          }
        })
        state.integratedConfig.langs = result
      }
      state.langs = integratedConfig.langs || result
      const subs =
        state.integratedConfig?.integratedConfigPhoneSubscribe.langs || []
      state.langs.forEach(item => {
        const data = subs.find(item1 => item1.langCode === item.langCode)
        if (data) {
          item.checkoutSmsSubscribeDesc = data.checkoutSmsSubscribeDesc
          item.checkoutSmsSubscribeText = data.checkoutSmsSubscribeText
          item.checkoutWhatsappSubscribeDesc =
            data.checkoutWhatsappSubscribeDesc
          item.checkoutWhatsappSubscribeText =
            data.checkoutWhatsappSubscribeText
        }
      })
      changeCheckLangData()

      // 将 Payment Successful Email订阅字段从默认语言同步到最外层
      const defaultLangData = state.langs.find(
        item => item.langCode === state.defaultLang
      )
      if (defaultLangData) {
        state.integratedConfig.emailSubscribeTitle =
          defaultLangData.emailSubscribeTitle || ''
        state.integratedConfig.emailSubscribeDescription =
          defaultLangData.emailSubscribeDescription || ''
        state.integratedConfig.emailSubscribeButtonText =
          defaultLangData.emailSubscribeButtonText || ''
        state.integratedConfig.emailSubscribeSuccessDesc =
          defaultLangData.emailSubscribeSuccessDesc || ''
      }
    }

    const changeCheckLangData = () => {
      const dataSource = state.langs.find(
        item => item.langCode === state.langCode
      )
      state.checkLangData = dataSource
    }
    const getSiteLang = async () => {
      const { data = {} } = await common_lang_get({
        channelId,
        siteId,
        brandId,
        terminalId
      })
      if (!data) {
        state.isShow = false
        return
      }
      const {
        defaultLanguageCode = '',
        languageMap = [],
        defaultCurrency = '未配置默认币种'
      } = data
      state.defaultCurrency = defaultCurrency
      if (!languageMap || (Array.isArray(languageMap) && !languageMap.length)) {
        state.isShow = false
        return
      }

      const result = []

      Object.entries(languageMap).map(([key, value]) => {
        const item = {
          label: key,
          value: value
        }
        if (value !== defaultLanguageCode) {
          result.push(item)
          return
        }
        result.unshift(item)
      })

      state.langList = result

      state.languageMap = data.languageMap || []
      state.defaultLang = result[0].value
      state.langCode = result[0].value
    }

    provide('initState', state)
    // provide('modalData', modalData)
    onMounted(async () => {
      await getSiteLang()
      if (
        !state.languageMap ||
        (Array.isArray(state.languageMap) && !state.languageMap.length)
      ) {
        state.isShow = false
        return
      }
      state.queryParams = state.route.query
      state.initList()
    })
    watch(
      () => state.langCode,
      (val, valOld) => {
        state.disabled = !(state.defaultLang === state.langCode)
        val && valOld && changeCheckLangData()
      },
      {
        deep: true,
        immediate: true
      }
    )
    watch(
      () => [
        state.modalData.scene,
        state.modalData.pcStatus,
        state.modalData.mStatus
      ],
      () => {
        const { scene, pcStatus, mStatus } = state.modalData
        const { subscribeFormState = {}, langCode = '', subscribeModal } = state
        const { langs = [] } = subscribeFormState
        if (!subscribeModal) {
          return
        }
        state.subscribeFormState.langs = langs.map(item => {
          if (item.langCode !== langCode) {
            item.scene = scene
            item.pcStatus = pcStatus
            item.mStatus = mStatus
          }
          return item
        })
      }
    )
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style>
@font-face {
  font-family: 'Muli-ExtraBold';
  src: url('https://cdn-image.kapeixi.cn/web/46e5a7eb-2b54-4ab9-805c-157cbba63070/Satoshi-Black.woff2');
}

.Muli-ExtraBold,
.ql-font-Muli-ExtraBold {
  font-family: Muli-ExtraBold;
}

@font-face {
  font-family: 'Muli-Bold';
  src: url('https://cdn-image.kapeixi.cn/web/c8fca30d-913f-49af-931c-c8142f02d1ef/Satoshi-Bold.woff2');
}

.Muli-Bold,
.ql-font-Muli-Bold {
  font-family: Muli-Bold;
}

@font-face {
  font-family: 'Muli-SemiBold';
  src: url('https://cdn-image.kapeixi.cn/web/316fb9cc-e896-49bb-a52c-f14e9eab02e8/Satoshi-Medium.woff2');
}

.Muli-SemiBold,
.ql-font-Muli-SemiBold {
  font-family: Muli-SemiBold;
}

@font-face {
  font-family: 'Muli-Light';
  src: url('https://cdn-image.kapeixi.cn/web/ca5162f5-22ec-4bca-9686-2efac5d29604/Satoshi-Regular.woff2');
}

.AvenirNext-Regular,
.ql-font-AvenirNext-Regular {
  font-family: Muli-Light;
}
</style>
<style scoped>
.bottomBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999;
  padding: 10px;
  width: calc(100%);
  border-top: 1px solid #f8f8f8;
}
</style>
<style>
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {
  content: '12px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
  content: '16px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
  content: '20px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {
  content: '22px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
  content: '24px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {
  content: '26px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {
  content: '28px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='30px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='30px']::before {
  content: '30px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='34px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='34px']::before {
  content: '34px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
  content: '36px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='38px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='38px']::before {
  content: '38px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='40px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='40px']::before {
  content: '40px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='45px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='45px']::before {
  content: '45px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='50px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='50px']::before {
  content: '50px';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-ExtraBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-ExtraBold']::before {
  content: 'AvenirNext-Bold';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Bold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Bold']::before {
  content: 'AvenirNext-Demi';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-SemiBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-SemiBold']::before {
  content: 'AvenirNext-Medium';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Light']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Light']::before {
  content: 'AvenirNext-Regular';
}

/**设置默认字体显示
**/
.ql-container {
  font-size: 16px;
}

.ql-disabled {
  color: rgba(0, 0, 0, 0.25);
}
</style>
